namespace BWS
{
	export class List
		extends ui.tab.TabHTMLPresentation
	{
		private MList: SPA.gui.Listing<Wollmilch.BWS.IBWS>;
		private MData: Wollmilch.BWS.IBWS[][];

		public constructor()
		{
			super();

			this.MData = new Array();

			this.MList = new SPA.gui.Listing<Wollmilch.BWS.IBWS>(
				new SPA.BWS.data.BWSTableDataModel(
				{
					header: true,
					headerEnd: true,
					style:
					{
						condense: true,
						hover: true,
						stripes: true,
					},
				},
				),
				15,
				( list: SPA.gui.Listing<Wollmilch.BWS.IBWS>, count: number, page: number ): void =>
				{
					count = clamp( count, 5, 50 );

					const idx = this.MData.findIndex( ( value, index ) =>
					{
						return index === page && value !== undefined;
					},
					);

					if ( idx > -1 )
					{
						list.Content().Data( this.MData[ idx ] );
						list.Content().rebuild();

						return;
					}

					new Wollmilch.AJAX(
						{
							on:
							{
								success: ( text: string ): void =>
								{
									let obj = null;
									try
									{
										obj = Wollmilch.jsonize( text );
									}
									catch ( e )
									{
										app.addNotify(
											{
												body: [ ui.text( app.getMessage( 'BWS.ERROR.no_json' ) ) ],
												context: 'warning',
												timeout: Number(app.getConfigValue("ToastTimeout")),
												title: [ ui.h( 3, app.getMessage( 'BWS.ERROR.title' ) ) ],
											},
										);

										return;
									}

									if ( !obj || !obj.success )
									{
										app.addNotify(
											{
												body: [ ui.text( app.getMessage( 'BWS.ERROR.no_success' ) ) ],
												context: 'info',
												timeout: Number(app.getConfigValue("ToastTimeout")),
												title: [ ui.h( 3, app.getMessage( 'BWS.ERROR.title' ) ) ],
											},
										);

										return;
									}

									list.Content().Data( obj.data );
									list.Content().rebuild();

									list.SetPage( page, obj.count );

									this.MData[ page ] = obj.data;
								},
							},
							url: 'BWS/list/' + app.getAuthenticationManager().getPerson() + '/limit/' + count + '/page/' + page,
						},
						Wollmilch.AJAXCallbase_e.BWS,
					).send();

				},
			);
		}

		public rebuild( root: JQuery|ui.base.BaseHTMLElement ): List
		{
			super.rebuild( root );

			this.empty();

			this.MList.rebuild( new ui.Box.Box().appendTo( this ) );

			if ( this.m_Entry )
			{
				this.m_Entry.DeactivateReloadSpin();
			}

			return this;
		}

	}
}
